"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const Scrollable_1 = require("~/components/UI/Scrollable");
const CatalogGroup_module_scss_1 = __importDefault(require("./CatalogGroup.module.scss"));
function CatalogGroup({ children }) {
    return (react_1.default.createElement("div", { className: CatalogGroup_module_scss_1.default.content },
        react_1.default.createElement(Scrollable_1.Scrollable, { direction: "vertical", scrollbar: true },
            react_1.default.createElement("div", { className: CatalogGroup_module_scss_1.default.group }, children))));
}
exports.default = CatalogGroup;
